import { ConcreteEncodable } from "./ConcreteEncodable";

import { STPMessageEncoder } from "../../encoder/STPMessageEncoder";

import * as CubiqTS from "../../index";

export class STPMessage extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.stp.bridge.STPMessage";

  /*FID=1*/
  public stpMessage: string;
  /*FID=2*/
  public orderType: CubiqTS.OrderType;
  /*FID=3*/
  public internalRequesterOrderId: CubiqTS.Long | null = null;
  /*FID=4*/
  public senderReference: string;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = STPMessageEncoder.Instance;
    this.setEncodableType(STPMessage.enType);
    //Model
  }

  public toString(): string {
    return (
      "STPMessage[" +
      "stpMessage=" +
      this.stpMessage +
      "orderType=" +
      this.orderType +
      "internalRequesterOrderId=" +
      this.internalRequesterOrderId +
      "senderReference=" +
      this.senderReference +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
